(function () {
  'use strict';

  var SELECTOR_ROOT = '[data-region-selector]';
  var mobileRegionQuery = window.matchMedia('(max-width: 768px)');
  var redirectMapCache = {};
  var localePathPattern = /^\/(de|fr|es-es|es|it|pl|el|nl)(\/|$)/i;

  function normalizeSearchText(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/\p{M}+/gu, '')
      .toLocaleLowerCase(document.documentElement.lang || undefined)
      .replace(/[^\p{L}\p{N}\s/.-]+/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      url.protocol = 'https:';
      url.hash = '';
      url.search = '';
      if (url.pathname !== '/' && url.pathname.slice(-1) === '/') {
        url.pathname = url.pathname.slice(0, -1);
      }
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function currentUrlCandidates() {
    var current = new URL(window.location.href);
    var candidates = [normalizeUrl(current.href)];
    var localizedPath = current.pathname.match(localePathPattern);

    if (localizedPath) {
      current.pathname = current.pathname.replace(localePathPattern, '/');
      candidates.push(normalizeUrl(current.href));
    }

    return candidates.filter(Boolean);
  }

  function getRegionPath(value) {
    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, '') || '/';
    } catch (error) {
      return '/';
    }
  }

  function findActiveRegionItem(regionRoot) {
    if (!regionRoot) return null;

    var currentUrl = new URL(window.location.href);
    var currentHost = currentUrl.hostname.replace(/^www\./, "");
    var currentPath = currentUrl.pathname.replace(/\/$/, "") || "/";
    var currentCountryParam = (currentUrl.searchParams.get("country") || "").toUpperCase();

    var isPreviewHost = currentHost.indexOf("myshopify.com") !== -1 || currentHost === "localhost" || currentHost === "127.0.0.1";
    var isEuStoreHost = currentHost === "global.arzopa.com" || isPreviewHost;

    var items = Array.prototype.slice.call(regionRoot.querySelectorAll("[data-region-label][data-region-url]"));
    if (!items.length) return null;

    function getItemMeta(item) {
      var itemUrl;
      try {
        itemUrl = new URL(item.dataset.regionUrl, window.location.origin);
      } catch (e) {
        itemUrl = new URL("/", window.location.origin);
      }
      var itemHost = itemUrl.hostname.replace(/^www\./, "");
      var itemPath = getRegionPath(itemUrl.href).toLowerCase();
      var itemCountryParam = (itemUrl.searchParams.get("country") || item.dataset.euMarket || "").toUpperCase();
      var itemLocale = (item.dataset.euLocale || item.dataset.languageCode || "").toLowerCase();
      var itemCountryCode = (item.dataset.countryCode || "").toUpperCase();
      var itemCountryName = (item.dataset.regionCountry || "").toLowerCase();

      return {
        item: item,
        host: itemHost,
        path: itemPath,
        countryParam: itemCountryParam,
        locale: itemLocale,
        countryCode: itemCountryCode,
        countryName: itemCountryName,
        isGlobal: itemHost === "global.arzopa.com" || item.dataset.targetSite === "global" || itemPath.indexOf("/") === 0
      };
    }

    var parsedItems = items.map(getItemMeta);

    if (isEuStoreHost) {
      var euItems = parsedItems.filter(function (meta) {
        return meta.isGlobal || meta.host === "global.arzopa.com";
      });

      // 1. Match ?country=xx query parameter (e.g. ?country=gb or ?country=au)
      if (currentCountryParam) {
        for (var i = 0; i < euItems.length; i++) {
          var meta = euItems[i];
          if (meta.countryParam === currentCountryParam || meta.countryCode === currentCountryParam) {
            return meta.item;
          }
        }
      }

      // 2. Match locale subfolder in current path (e.g. /nl, /de, /fr, /es-es, /es, /it, /pl, /el)
      var localeMatch = currentPath.match(localePathPattern);
      if (localeMatch) {
        var currentLocalePrefix = localeMatch[1].toLowerCase();
        for (var j = 0; j < euItems.length; j++) {
          var subMeta = euItems[j];
          if (subMeta.locale === currentLocalePrefix || subMeta.path === "/" + currentLocalePrefix) {
            return subMeta.item;
          }
          if ((currentLocalePrefix === "es" || currentLocalePrefix === "es-es") &&
              (subMeta.locale === "es" || subMeta.locale === "es-es")) {
            return subMeta.item;
          }
        }
      }

      // 3. Match default root store (Europe / English) when no country param and no locale subfolder
      if (!currentCountryParam && !localeMatch) {
        for (var k = 0; k < euItems.length; k++) {
          var rootMeta = euItems[k];
          if (rootMeta.countryName === "europe" || rootMeta.locale === "global-en") {
            return rootMeta.item;
          }
          if (rootMeta.path === "/" && !rootMeta.countryParam) {
            return rootMeta.item;
          }
        }
      }
    }

    // 4. External domain match (e.g. www.arzopa.com, ca.arzopa.com, jp.arzopa.com, br.arzopa.com)
    for (var m = 0; m < parsedItems.length; m++) {
      if (parsedItems[m].host === currentHost) {
        return parsedItems[m].item;
      }
    }

    return items[0] || null;
  }

  function updateDisplayedRegion(item) {
    if (!item) return;

    var label = item.dataset.regionLabel || '';
    var country = item.dataset.regionCountry || (label.indexOf('/') !== -1 ? label.split('/')[0].trim() : label);
    var flagUrl = item.dataset.flagUrl || '';
    if (!flagUrl) {
      var flagImg = item.querySelector('.ar-region-item__icon img');
      if (flagImg && flagImg.src) flagUrl = flagImg.src;
    }

    // 1. Update Header Trigger
    var headerTriggers = document.querySelectorAll(SELECTOR_ROOT + ' #ar-current-country, #ar-current-country');
    Array.prototype.forEach.call(headerTriggers, function (trigger) {
      if (label) {
        trigger.setAttribute('aria-label', label);
        trigger.setAttribute('title', label);
      }
      var headerFlag = trigger.querySelector('.ar-current-flag');
      var globeIcon = trigger.querySelector('.ar-region-globe-icon');
      if (headerFlag && flagUrl) {
        headerFlag.src = flagUrl;
        headerFlag.alt = label || country;
      } else if (!headerFlag && flagUrl) {
        var newHeaderImg = document.createElement('img');
        newHeaderImg.className = 'ar-current-flag';
        newHeaderImg.src = flagUrl;
        newHeaderImg.width = 30;
        newHeaderImg.height = 30;
        newHeaderImg.alt = label || country;
        newHeaderImg.loading = 'lazy';
        if (globeIcon) {
          globeIcon.replaceWith(newHeaderImg);
        } else {
          trigger.insertBefore(newHeaderImg, trigger.firstChild);
        }
      }
      var headerText = trigger.querySelector('.ar-current-country-text');
      if (headerText && label) {
        headerText.textContent = label;
      }
    });

    // 2. Update Footer Trigger
    var footerTriggers = document.querySelectorAll('.ar-footer-trigger');
    Array.prototype.forEach.call(footerTriggers, function (trigger) {
      if (label) {
        trigger.setAttribute('aria-label', label);
        trigger.setAttribute('title', label);
      }
      var footerFlag = trigger.querySelector('.ar-footer-trigger__flag');
      if (footerFlag && flagUrl) {
        footerFlag.src = flagUrl;
        footerFlag.alt = label || country;
      } else if (!footerFlag && flagUrl) {
        var placeholder = trigger.querySelector('.ar-footer-trigger__flag-placeholder');
        if (placeholder) {
          var newImg = document.createElement('img');
          newImg.className = 'ar-footer-trigger__flag';
          newImg.src = flagUrl;
          newImg.width = 30;
          newImg.height = 30;
          newImg.alt = label || country;
          newImg.loading = 'lazy';
          placeholder.replaceWith(newImg);
        }
      }
      var footerLabel = trigger.querySelector('.ar-footer-trigger__label');
      if (footerLabel && label) {
        footerLabel.textContent = label;
      }
    });

    // 3. Update Drawer Trigger
    var drawerTriggers = document.querySelectorAll('.ar-drawer-trigger');
    Array.prototype.forEach.call(drawerTriggers, function (trigger) {
      if (label) {
        trigger.setAttribute('aria-label', label);
        trigger.setAttribute('title', label);
      }
      var drawerFlag = trigger.querySelector('.ar-drawer-trigger__flag');
      if (drawerFlag && flagUrl) {
        drawerFlag.src = flagUrl;
        drawerFlag.alt = label || country;
      } else if (!drawerFlag && flagUrl) {
        var drawerPlaceholder = trigger.querySelector('.ar-drawer-trigger__flag-placeholder');
        if (drawerPlaceholder) {
          var newDrawerImg = document.createElement('img');
          newDrawerImg.className = 'ar-drawer-trigger__flag';
          newDrawerImg.src = flagUrl;
          newDrawerImg.width = 30;
          newDrawerImg.height = 30;
          newDrawerImg.alt = label || country;
          newDrawerImg.loading = 'lazy';
          drawerPlaceholder.replaceWith(newDrawerImg);
        }
      }
      var drawerLabel = trigger.querySelector('.ar-drawer-trigger__label');
      if (drawerLabel && label) {
        drawerLabel.textContent = label;
      }
    });

    // 4. Highlight active item in dialog list
    var allItems = document.querySelectorAll('.ar-region-item__link');
    Array.prototype.forEach.call(allItems, function (link) {
      var isCurrent = link === item;
      link.classList.toggle('is-current', isCurrent);
      if (isCurrent) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function updateCurrentRegionText(regionRoot) {
    if (!regionRoot) return;
    var bestMatch = findActiveRegionItem(regionRoot);
    if (bestMatch) {
      updateDisplayedRegion(bestMatch);
    }
  }

  function loadRedirectMap(mapUrl) {
    if (!mapUrl) return Promise.resolve(null);
    if (!redirectMapCache[mapUrl]) {
      redirectMapCache[mapUrl] = window.fetch(mapUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load region redirect map');
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }

    return redirectMapCache[mapUrl];
  }

  function findRedirectUrl(map, targetSite, fallbackUrl) {
    if (!map || !targetSite) return fallbackUrl;

    var candidates = currentUrlCandidates();
    var routes = Array.isArray(map.routes) ? map.routes : [];
    var matchedRoute = routes.find(function (route) {
      return route.urls && Object.keys(route.urls).some(function (siteKey) {
        return candidates.indexOf(normalizeUrl(route.urls[siteKey])) !== -1;
      });
    });

    if (matchedRoute && matchedRoute.urls && matchedRoute.urls[targetSite]) {
      return matchedRoute.urls[targetSite];
    }

    var currentHost = window.location.hostname.replace(/^www\./, "");
    var isPreviewHost = currentHost.indexOf("myshopify.com") !== -1 || currentHost === "localhost" || currentHost === "127.0.0.1";
    if (targetSite === "global" && (currentHost === "global.arzopa.com" || isPreviewHost)) {
      try {
        var sameSiteUrl = new URL(window.location.href);
        sameSiteUrl.pathname = sameSiteUrl.pathname.replace(localePathPattern, "/") || "/";
        return sameSiteUrl.toString();
      } catch (e) {}
    }

    return (map.fallback_url_by_site && map.fallback_url_by_site[targetSite]) || fallbackUrl;
  }

  function initRegionSelector(regionRoot) {
    if (!regionRoot) return;
    if (regionRoot.dataset.regionSelectorReady === 'true') {
      updateCurrentRegionText(regionRoot);
      return;
    }
    regionRoot.dataset.regionSelectorReady = 'true';

    var dialog = regionRoot.querySelector('.ar-select-country-dialog');
    var localizationForm = regionRoot.querySelector('form[action*="/localization"]');
    var countryInput = localizationForm ? localizationForm.querySelector('input[name="country_code"]') : null;
    var localeInput = localizationForm ? localizationForm.querySelector('input[name="locale_code"]') : null;
    var returnToInput = localizationForm ? localizationForm.querySelector('input[name="return_to"]') : null;
    var searchInput = regionRoot.querySelector('.ar-region-search__input');
    var searchFrame = null;
    var redirectMapUrl = regionRoot.dataset.redirectMapUrl;

    updateCurrentRegionText(regionRoot);

    var regionGroups = Array.prototype.map.call(regionRoot.querySelectorAll('.ar-region-group'), function (group) {
      var items = Array.prototype.map.call(group.querySelectorAll('.ar-region-item'), function (item) {
        var name = item.querySelector('.ar-region-item__name');
        var meta = item.querySelector('.ar-region-item__meta');

        return {
          element: item,
          searchText: normalizeSearchText([
            name ? name.textContent : '',
            meta ? meta.textContent : ''
          ].join(' '))
        };
      });

      return {
        element: group,
        items: items
      };
    });

    function filterRegions(rawQuery) {
      var terms = normalizeSearchText(rawQuery).split(' ').filter(Boolean);

      regionGroups.forEach(function (groupData) {
        var visibleCount = 0;

        groupData.items.forEach(function (itemData) {
          var isVisible = terms.length === 0 || terms.every(function (term) {
            return itemData.searchText.indexOf(term) !== -1;
          });

          itemData.element.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        groupData.element.hidden = visibleCount === 0;
      });
    }

    if (dialog && searchInput) {
      dialog.addEventListener('modal:handleAfterShow', function () {
        window.requestAnimationFrame(function () {
          searchInput.focus();
        });
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        if (searchFrame) window.cancelAnimationFrame(searchFrame);

        searchFrame = window.requestAnimationFrame(function () {
          filterRegions(searchInput.value);
          searchFrame = null;
        });
      });

      searchInput.addEventListener('search', function () {
        filterRegions(searchInput.value);
      });
    }

    // Group toggle clicks: dialog may be portaled to <body>, so listen on document.
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('.ar-region-group__toggle');
      if (!toggle || !mobileRegionQuery.matches) return;

      var group = toggle.closest('.ar-region-group');
      if (!group) return;

      var isCollapsed = group.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', String(!isCollapsed));
    });

    // Redirect link clicks: dialog may be portaled to <body>, so listen on document
    // and skip the regionRoot.contains() check (it would always fail for portaled links).
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.js-ar-region-redirect');
      if (!link || !link.dataset.targetSite) return;

      event.preventDefault();
      updateDisplayedRegion(link);

      var fallbackUrl = link.dataset.defaultUrl || link.getAttribute('href') || '/';
      var euLocale = link.dataset.euLocale;
      var euMarket = link.dataset.euMarket;

      loadRedirectMap(redirectMapUrl).then(function (map) {
        var targetUrl = findRedirectUrl(map, link.dataset.targetSite, fallbackUrl);

        // EU multi-language: when target is global.arzopa.com and a locale prefix
        // is configured (de/fr/es/it/pl/el/nl), prepend it to the pathname.
        if (euLocale && euLocale !== 'global-en') {
          try {
            var u = new URL(targetUrl);
            if (u.hostname === 'global.arzopa.com') {
              var path = u.pathname;
              if (path.charAt(0) !== '/') path = '/' + path;
              path = path.replace(localePathPattern, '/');
              u.pathname = '/' + euLocale + path;
              targetUrl = u.toString();
            }
          } catch (e) {}
        }

        // EU market routing (?country=gb, ?country=au)
        if (euMarket) {
          try {
            var marketUrl = new URL(targetUrl);
            marketUrl.searchParams.set('country', euMarket.toLowerCase());
            targetUrl = marketUrl.toString();
          } catch (e) {}
        }

        window.location.href = targetUrl;
      });
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.js-ar-region-localization-submit');
      if (!button) return;

      updateDisplayedRegion(button);

      var activeForm = document.querySelector(SELECTOR_ROOT + ' form[action*="/localization"]') ||
                        document.querySelector('form[action*="/localization"]');
      if (!activeForm) {
        window.location.href = button.dataset.returnTo || '/';
        return;
      }

      var cInput = activeForm.querySelector('input[name="country_code"]');
      var lInput = activeForm.querySelector('input[name="locale_code"]');
      var rInput = activeForm.querySelector('input[name="return_to"]');

      if (cInput) {
        if (button.dataset.countryCode) {
          cInput.value = button.dataset.countryCode;
          cInput.disabled = false;
        } else {
          cInput.value = '';
          cInput.disabled = true;
        }
      }

      if (lInput) lInput.value = button.dataset.languageCode || '';
      if (rInput) {
        try {
          var currentPathWithoutLocale = window.location.pathname.replace(localePathPattern, "/") || "/";
          var currentSearch = new URLSearchParams(window.location.search);
          if (button.dataset.countryCode === "GB" || button.dataset.euMarket === "GB") {
            currentSearch.set("country", "gb");
          } else {
            currentSearch.delete("country");
          }
          var searchStr = currentSearch.toString();
          rInput.value = currentPathWithoutLocale + (searchStr ? "?" + searchStr : "");
        } catch (e) {
          rInput.value = button.dataset.returnTo || window.location.pathname;
        }
      }

      if (!button.dataset.countryCode && !button.dataset.languageCode) {
        window.location.href = button.dataset.returnTo || '/';
        return;
      }

      activeForm.submit();
    });

  }

  // Region trigger proxies (footer / drawer): lightweight buttons that
  // delegate to the main trigger (#ar-current-country) so we only
  // initialize one dialog instance.
  document.addEventListener('click', function (event) {
    var proxy = event.target.closest('[data-footer-region-trigger], [data-drawer-region-trigger]');
    if (!proxy) return;
    event.preventDefault();
    var mainTrigger = document.querySelector(SELECTOR_ROOT + ' #ar-current-country');
    if (mainTrigger) mainTrigger.click();
  });

  function initRegionSelectors(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(SELECTOR_ROOT), initRegionSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRegionSelectors(document);
    });
  } else {
    initRegionSelectors(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initRegionSelectors(event.target);
  });

  window.addEventListener('load', function () {
    initRegionSelectors(document);
  });
})();
